import Head from "next/head";
import React, { useEffect } from "react";
import { useRouter } from "next/router";

export const openKodifChat = (message) => {
  const iframe = document.getElementById("kodif-chat-widget");
  if (!iframe) return;
  iframe.contentWindow.postMessage(
    { type: "toggle-expanded", isExpanded: true },
    "*"
  );
  if (message) {
    iframe.contentWindow.postMessage(
      { type: "external-message", payload: { text: message } },
      "*"
    );
  }
};

export const KodifChat = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      if (typeof window === "undefined") return;

      const widget = document.getElementById("kodif-chat-widget");
      if (widget) {
        if (url.includes("/cancel")) {
          widget.style.display = "none";
        } else {
          widget.style.display = "block";
        }
      }
    };
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  return (
    <Head>
      <script
        async
        src="https://autopilot.kodif.io/chat/v1/application/2083b98d-dcd1-4b92-9b1f-d3eff3da0705/widget-script"
      ></script>
    </Head>
  );
};
